import React from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  useTheme
} from "@mui/material";

export function WizardStepper({ steps, activeStep }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mb: { xs: 2, sm: 3 },
        overflowX: { xs: "auto", sm: "visible" },
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={null}
        sx={{
          maxWidth: { xs: "unset", sm: "681px" },
          minWidth: { xs: 520, sm: "unset" },
          mt: { xs: 2, sm: "31px" },
          mb: { xs: 2, sm: "30px" },

          "& .MuiStep-root": {
            minWidth: 140,
            flex: "unset",  
          },

          "& .MuiStep-root:first-of-type": {
            pl: 0,
          },

          "& .MuiStep-root:last-of-type": {
            pr: 0,
          },
        }}
      >
        {steps.map((step) => (
          <Step key={step.id}>
            <StepLabel
              sx={{
                "& .MuiStepIcon-root": {
                  width: { xs: 36, sm: 41 },
                  height: { xs: 36, sm: 41 },
                  color: "#9CA3AF",
                },

                "& .MuiStepIcon-root.Mui-active": {
                  color: theme.palette.custom.purple[500],
                },

                "& .MuiStepIcon-root.Mui-completed": {
                  color: theme.palette.custom.purple[500],
                },

                "& .MuiStepLabel-label": {
                  mt: 1,
                  fontSize: { xs: 12, sm: 14 },
                  color: "#64748B",
                  fontWeight: 500,
                  textAlign: "center",
                  lineHeight: 1.3,
                },
                

                "& .MuiStepLabel-label.Mui-active": {
                  color: theme.palette.custom.gray[700],
                },

                "& .MuiStepLabel-label.Mui-completed": {
                  color: "#475569",
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
